import React, { useCallback, useState } from "react";

import styled, { withTheme } from "styled-components";
import { useForm } from "react-hook-form";
import { Bookmark } from "@material-ui/icons";

import Modal from "common/Modal";
import Button from "common/Button";
import InputWithLabel from "common/InputWithLabel";
import { createFilter } from "utils/api";
import { NotificationManager } from "react-notifications";

const StyledForm = styled.form`
  padding: 0px 18px 10px 18px;
`;

function SaveSearchModal({ reload, isOpen, setIsOpen, searchValues, setSelectedFilter, theme }) {
  const { handleSubmit, register, errors } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const onSubmit = useCallback(
    async values => {
      const dataToSubmit = { filter_name: values.filter_name, ...searchValues };
      try {
        setIsLoading(true);
        const data = await createFilter(dataToSubmit);
        setIsLoading(false);
        setSelectedFilter(data);
        reload();
        closeModal();
      } catch (e) {
        NotificationManager.error(e.toString());
      }

      // } catch (error) {
      //   // setSubmitError(error.msg);
      //   console.log(error);
      // }
    },
    [closeModal, reload, searchValues, setSelectedFilter]
  );

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      modalTitle="Suchanfrage / Suchparameter speichern"
      Icon={Bookmark}
    >
      <p style={{ fontSize: 12, padding: "0px 20px" }}>
        Bitte vergeben Sie für die zu speichernde Suchanfrage einen Namen bzw. Titel ein. Künftig
        wird diese Suchanfgrage dann in der Firmensuche unter diesem Namen wieder aufrufbar sein.
      </p>
      <StyledForm onSubmit={handleSubmit(onSubmit)}>
        <InputWithLabel
          reg={register}
          name="filter_name"
          type="text"
          label="Suche"
          errors={errors}
          companySearch
        />
        <Button
          type="button"
          onClick={closeModal}
          text="Zurück zur Firmensuche"
          border="1px solid #eaecee"
          margin="0 15px 0 0"
          color={theme.primaryColor}
          background="#fff"
        />
        <Button
          type="submit"
          text="Suche speichern"
          border="1px solid #eaecee"
          margin="0 15px 0 0"
          color={theme.primaryColor}
          background="#fff"
          disabled={isLoading}
        />
      </StyledForm>
    </Modal>
  );
}

export default withTheme(SaveSearchModal);
